export const celebs = [
  {
    'name': 'Adam Sandler',
    'image': 'Adam Sandler.jpeg',
    'filename': 'Adam Sandler'
  },
  {
    'name': 'Addison Rae',
    'image': 'Addison Rae.jpeg',
    'filename': 'Addison Rae'
  },
  {
    'name': 'Adriana Lima',
    'image': 'Adriana Lima.jpeg',
    'filename': 'Adriana Lima'
  },
  {
    'name': 'Alan Ritchson',
    'image': 'Alan Ritchson.jpeg',
    'filename': 'Alan Ritchson'
  },
  {
    'name': 'Alan Walker',
    'image': 'Alan Walker.jpeg',
    'filename': 'Alan Walker'
  },
  {
    'name': 'Alessandra Ambrosio',
    'image': 'Alessandra Ambrosio.jpeg',
    'filename': 'Alessandra Ambrosio'
  },
  {
    'name': 'Alessia Cara',
    'image': 'Alessia Cara.jpeg',
    'filename': 'Alessia Cara'
  },
  {
    'name': 'Alex Ovechkin',
    'image': 'Alex Ovechkin.jpeg',
    'filename': 'Alex Ovechkin'
  },
  {
    'name': 'Alexandra Daddario',
    'image': 'Alexandra Daddario.jpeg',
    'filename': 'Alexandra Daddario'
  },
  {
    'name': 'Amber Heard',
    'image': 'Amber Heard.jpg',
    'filename': 'Amber Heard'
  },
  {
    'name': 'Angelina Jolie',
    'image': 'Angelina Jolie.jpeg',
    'filename': 'Angelina Jolie'
  },
  {
    'name': 'Antonio Banderas',
    'image': 'Antonio Banderas.jpeg',
    'filename': 'Antonio Banderas'
  },
  {
    'name': 'Ariana Grande',
    'image': 'Ariana Grande.jpeg',
    'filename': 'Ariana Grande'
  },
  {
    'name': 'Asa Butterfield',
    'image': 'Asa Butterfield.jpeg',
    'filename': 'Asa Butterfield'
  },
  {
    'name': 'Atta Halilintar',
    'image': 'Atta Halilintar.jpeg',
    'filename': 'Atta Halilintar'
  },
  {
    'name': 'AuronPlay',
    'image': 'AuronPlay.jpeg',
    'filename': 'AuronPlay'
  },
  {
    'name': 'Badabun',
    'image': 'Badabun.jpeg',
    'filename': 'Badabun'
  },
  {
    'name': 'Ben Affleck',
    'image': 'Ben Affleck.jpeg',
    'filename': 'Ben Affleck'
  },
  {
    'name': 'Benedict Cumberbatch',
    'image': 'Benedict Cumberbatch.jpeg',
    'filename': 'Benedict Cumberbatch'
  },
  {
    'name': 'Beyonce',
    'image': 'Beyonce.jpeg',
    'filename': 'Beyonce'
  },
  {
    'name': 'Billie Eilish',
    'image': 'Billie Eilish.jpeg',
    'filename': 'Billie Eilish'
  },
  {
    'name': 'Bonnie Wright',
    'image': 'Bonnie Wright.jpg',
    'filename': 'Bonnie Wright'
  },
  {
    'name': 'Brad Pitt',
    'image': 'Brad Pitt.jpeg',
    'filename': 'Brad Pitt'
  },
  {
    'name': 'Bradley Cooper',
    'image': 'Bradley Cooper.jpeg',
    'filename': 'Bradley Cooper'
  },
  {
    'name': 'Brie Larson',
    'image': 'Brie Larson.jpeg',
    'filename': 'Brie Larson'
  },
  {
    'name': 'Bruce Willis',
    'image': 'Bruce Willis.jpeg',
    'filename': 'Bruce Willis'
  },
  {
    'name': 'Bruno Mars',
    'image': 'Bruno Mars.jpeg',
    'filename': 'Bruno Mars'
  },
  {
    'name': 'Calvin Harris',
    'image': 'Calvin Harris.jpeg',
    'filename': 'Calvin Harris'
  },
  {
    'name': 'Camila Cabello',
    'image': 'Camila Cabello.jpeg',
    'filename': 'Camila Cabello'
  },
  {
    'name': 'Candice Swanepoel',
    'image': 'Candice Swanepoel.jpeg',
    'filename': 'Candice Swanepoel'
  },
  {
    'name': 'Cara Delevingne',
    'image': 'Cara Delevingne.jpeg',
    'filename': 'Cara Delevingne'
  },
  {
    'name': 'Cardi B',
    'image': 'Cardi B.jpeg',
    'filename': 'Cardi B'
  },
  {
    'name': 'Cazzie David',
    'image': 'Cazzie David.jpeg',
    'filename': 'Cazzie David'
  },
  {
    'name': 'Chadwick Boseman',
    'image': 'Chadwick Boseman.jpeg',
    'filename': 'Chadwick Boseman'
  },
  {
    'name': 'Charles Melton',
    'image': 'Charles Melton.jpeg',
    'filename': 'Charles Melton'
  },
  {
    'name': 'Charli Damelio',
    'image': 'Charli Damelio.jpeg',
    'filename': 'Charli Damelio'
  },
  {
    'name': 'Charlie Puth',
    'image': 'Charlie Puth.jpg',
    'filename': 'Charlie Puth'
  },
  {
    'name': 'Chloe Grace Moretz',
    'image': 'Chloe Grace Moretz.jpeg',
    'filename': 'Chloe Grace Moretz'
  },
  {
    'name': 'Chris Brown',
    'image': 'Chris Brown.jpeg',
    'filename': 'Chris Brown'
  },
  {
    'name': 'Chris Evans',
    'image': 'Chris Evans.jpeg',
    'filename': 'Chris Evans'
  },
  {
    'name': 'Chris Hemsworth',
    'image': 'Chris Hemsworth.jpeg',
    'filename': 'Chris Hemsworth'
  },
  {
    'name': 'Chris Pratt',
    'image': 'Chris Pratt.jpeg',
    'filename': 'Chris Pratt'
  },
  {
    'name': 'Cobie Smulders',
    'image': 'Cobie Smulders.jpeg',
    'filename': 'Cobie Smulders'
  },
  {
    'name': 'Cole Sprouse',
    'image': 'Cole Sprouse.jpeg',
    'filename': 'Cole Sprouse'
  },
  {
    'name': 'Colson Baker',
    'image': 'Colson Baker.jpeg',
    'filename': 'Colson Baker'
  },
  {
    'name': 'Conor McGregor',
    'image': 'Conor McGregor.jpeg',
    'filename': 'Conor McGregor'
  },
  {
    'name': 'Cristiano Ronaldo',
    'image': 'Cristiano Ronaldo.jpg',
    'filename': 'Cristiano Ronaldo'
  },
  {
    'name': 'DJ Khaled',
    'image': 'DJ Khaled.jpg',
    'filename': 'DJ Khaled'
  },
  {
    'name': 'Daisy Ridley',
    'image': 'Daisy Ridley.jpeg',
    'filename': 'Daisy Ridley'
  },
  {
    'name': 'Dakota Fanning',
    'image': 'Dakota Fanning.jpeg',
    'filename': 'Dakota Fanning'
  },
  {
    'name': 'Dakota Johnson',
    'image': 'Dakota Johnson.jpeg',
    'filename': 'Dakota Johnson'
  },
  {
    'name': 'Danai Gurira',
    'image': 'Danai Gurira.jpeg',
    'filename': 'Danai Gurira'
  },
  {
    'name': 'Daniel Andre Tande',
    'image': 'Daniel Andre Tande.jpg',
    'filename': 'Daniel Andre Tande'
  },
  {
    'name': 'Daniel Radcliffe',
    'image': 'Daniel Radcliffe.jpeg',
    'filename': 'Daniel Radcliffe'
  },
  {
    'name': 'Daria Werbowy',
    'image': 'Daria Werbowy.jpeg',
    'filename': 'Daria Werbowy'
  },
  {
    'name': 'David Guetta',
    'image': 'David Guetta.jpeg',
    'filename': 'David Guetta'
  },
  {
    'name': 'Demi Lovato',
    'image': 'Demi Lovato.jpeg',
    'filename': 'Demi Lovato'
  },
  {
    'name': 'Drake',
    'image': 'Drake.jpeg',
    'filename': 'Drake'
  },
  {
    'name': 'Dua Lipa',
    'image': 'Dua Lipa.jpeg',
    'filename': 'Dua Lipa'
  },
  {
    'name': 'Dwayne Johnson',
    'image': 'Dwayne Johnson.jpeg',
    'filename': 'Dwayne Johnson'
  },
  {
    'name': 'Ed Sheeran',
    'image': 'Ed Sheeran.jpeg',
    'filename': 'Ed Sheeran'
  },
  {
    'name': 'El Rubius',
    'image': 'El Rubius.jpeg',
    'filename': 'El Rubius'
  },
  {
    'name': 'Elizabeth Debicki',
    'image': 'Elizabeth Debicki.jpeg',
    'filename': 'Elizabeth Debicki'
  },
  {
    'name': 'Elizabeth Olsen',
    'image': 'Elizabeth Olsen.jpeg',
    'filename': 'Elizabeth Olsen'
  },
  {
    'name': 'Ellen DeGeneres',
    'image': 'Ellen DeGeneres.jpeg',
    'filename': 'Ellen DeGeneres'
  },
  {
    'name': 'Ellie Goulding',
    'image': 'Ellie Goulding.jpeg',
    'filename': 'Ellie Goulding'
  },
  {
    'name': 'Eminem',
    'image': 'Eminem.jpeg',
    'filename': 'Eminem'
  },
  {
    'name': 'Emma Watson',
    'image': 'Emma Watson.jpeg',
    'filename': 'Emma Watson'
  },
  {
    'name': 'Evan Rachel Wood',
    'image': 'Evan Rachel Wood.jpeg',
    'filename': 'Evan Rachel Wood'
  },
  {
    'name': 'Ezra Miller',
    'image': 'Ezra Miller.jpg',
    'filename': 'Ezra Miller'
  },
  {
    'name': 'Felipe Neto',
    'image': 'Felipe Neto.jpeg',
    'filename': 'Felipe Neto'
  },
  {
    'name': 'Florence Kasumba',
    'image': 'Florence Kasumba.jpeg',
    'filename': 'Florence Kasumba'
  },
  {
    'name': 'Floyd Mayweather Jr',
    'image': 'Floyd Mayweather Jr.jpeg',
    'filename': 'Floyd Mayweather Jr'
  },
  {
    'name': 'Freya Allan',
    'image': 'Freya Allan.jpeg',
    'filename': 'Freya Allan'
  },
  {
    'name': 'Future',
    'image': 'Future.jpeg',
    'filename': 'Future'
  },
  {
    'name': 'Gal Gadot',
    'image': 'Gal Gadot.jpeg',
    'filename': 'Gal Gadot'
  },
  {
    'name': 'Gatlin Kate James',
    'image': 'Gatlin Kate James.jpeg',
    'filename': 'Gatlin Kate James'
  },
  {
    'name': 'George Sabanis',
    'image': 'George Sabanis.jpeg',
    'filename': 'George Sabanis'
  },
  {
    'name': 'Gigi Hadid',
    'image': 'Gigi Hadid.jpeg',
    'filename': 'Gigi Hadid'
  },
  {
    'name': 'Gina Carano',
    'image': 'Gina Carano.jpeg',
    'filename': 'Gina Carano'
  },
  {
    'name': 'Gordon Ramsay',
    'image': 'Gordon Ramsay.jpeg',
    'filename': 'Gordon Ramsay'
  },
  {
    'name': 'Gwyneth Paltrow',
    'image': 'Gwyneth Paltrow.jpeg',
    'filename': 'Gwyneth Paltrow'
  },
  {
    'name': 'Hailee Steinfeld',
    'image': 'Hailee Steinfeld.jpeg',
    'filename': 'Hailee Steinfeld'
  },
  {
    'name': 'Halle Berry',
    'image': 'Halle Berry.jpeg',
    'filename': 'Halle Berry'
  },
  {
    'name': 'Harry Styles',
    'image': 'Harry Styles.jpeg',
    'filename': 'Harry Styles'
  },
  {
    'name': 'Hayley Atwell',
    'image': 'Hayley Atwell.jpeg',
    'filename': 'Hayley Atwell'
  },
  {
    'name': 'Henry Cavill',
    'image': 'Henry Cavill.jpeg',
    'filename': 'Henry Cavill'
  },
  {
    'name': 'Hugh Jackman',
    'image': 'Hugh Jackman.jpeg',
    'filename': 'Hugh Jackman'
  },
  {
    'name': 'Ian Somerholder',
    'image': 'Ian Somerholder.jpeg',
    'filename': 'Ian Somerholder'
  },
  {
    'name': 'Ian from Smosh',
    'image': 'Ian from Smosh.jpg',
    'filename': 'Ian from Smosh'
  },
  {
    'name': 'J. Cole',
    'image': 'J. Cole.jpeg',
    'filename': 'J. Cole'
  },
  {
    'name': 'JackSepticEye',
    'image': 'JackSepticEye.jpeg',
    'filename': 'JackSepticEye'
  },
  {
    'name': 'Jacob DeGrom',
    'image': 'Jacob DeGrom.jpeg',
    'filename': 'Jacob DeGrom'
  },
  {
    'name': 'James Charles',
    'image': 'James Charles.jpeg',
    'filename': 'James Charles'
  },
  {
    'name': 'James Lebron',
    'image': 'James Lebron.jpg',
    'filename': 'James Lebron'
  },
  {
    'name': 'Jared Leto',
    'image': 'Jared Leto.jpeg',
    'filename': 'Jared Leto'
  },
  {
    'name': 'Jason Derulo',
    'image': 'Jason Derulo.jpg',
    'filename': 'Jason Derulo'
  },
  {
    'name': 'Jason Momoa',
    'image': 'Jason Momoa.jpeg',
    'filename': 'Jason Momoa'
  },
  {
    'name': 'Jay-Z',
    'image': 'Jay-Z.jpeg',
    'filename': 'Jay-Z'
  },
  {
    'name': 'Jenna Fischer',
    'image': 'Jenna Fischer.jpeg',
    'filename': 'Jenna Fischer'
  },
  {
    'name': 'Jennifer Aniston',
    'image': 'Jennifer Aniston.jpeg',
    'filename': 'Jennifer Aniston'
  },
  {
    'name': 'Jennifer Lawrence',
    'image': 'Jennifer Lawrence.jpeg',
    'filename': 'Jennifer Lawrence'
  },
  {
    'name': 'Jennifer Lopez',
    'image': 'Jennifer Lopez.jpeg',
    'filename': 'Jennifer Lopez'
  },
  {
    'name': 'Jenning Brower',
    'image': 'Jenning Brower.jpeg',
    'filename': 'Jenning Brower'
  },
  {
    'name': 'Jeremy Renner',
    'image': 'Jeremy Renner.jpeg',
    'filename': 'Jeremy Renner'
  },
  {
    'name': 'Jesse Eisenberg',
    'image': 'Jesse Eisenberg.jpeg',
    'filename': 'Jesse Eisenberg'
  },
  {
    'name': 'Jesse Williams',
    'image': 'Jesse Williams.jpeg',
    'filename': 'Jesse Williams'
  },
  {
    'name': 'Joan Smalls',
    'image': 'Joan Smalls.jpeg',
    'filename': 'Joan Smalls'
  },
  {
    'name': 'John Cena',
    'image': 'John Cena.jpg',
    'filename': 'John Cena'
  },
  {
    'name': 'Johnny Depp',
    'image': 'Johnny Depp.jpeg',
    'filename': 'Johnny Depp'
  },
  {
    'name': 'Josh Brolin',
    'image': 'Josh Brolin.jpeg',
    'filename': 'Josh Brolin'
  },
  {
    'name': 'Jourdan Dunn',
    'image': 'Jourdan Dunn.jpeg',
    'filename': 'Jourdan Dunn'
  },
  {
    'name': 'Juega German',
    'image': 'Juega German.jpg',
    'filename': 'Juega German'
  },
  {
    'name': 'Juice WRLD',
    'image': 'Juice WRLD.jpeg',
    'filename': 'Juice WRLD'
  },
  {
    'name': 'Julia Raleigh',
    'image': 'Julia Raleigh.jpeg',
    'filename': 'Julia Raleigh'
  },
  {
    'name': 'Justin Bieber',
    'image': 'Justin Bieber.jpeg',
    'filename': 'Justin Bieber'
  },
  {
    'name': 'Kanye West',
    'image': 'Kanye West.jpeg',
    'filename': 'Kanye West'
  },
  {
    'name': 'Karen Gillan',
    'image': 'Karen Gillan.jpeg',
    'filename': 'Karen Gillan'
  },
  {
    'name': 'Karin Jinsui',
    'image': 'Karin Jinsui.jpeg',
    'filename': 'Karin Jinsui'
  },
  {
    'name': 'Kate Moss',
    'image': 'Kate Moss.jpeg',
    'filename': 'Kate Moss'
  },
  {
    'name': 'Kate Upton',
    'image': 'Kate Upton.jpeg',
    'filename': 'Kate Upton'
  },
  {
    'name': 'Katie Mcgrath',
    'image': 'Katie Mcgrath.jpeg',
    'filename': 'Katie Mcgrath'
  },
  {
    'name': 'Katy Perry',
    'image': 'Katy Perry.jpeg',
    'filename': 'Katy Perry'
  },
  {
    'name': 'Keanu Reeves',
    'image': 'Keanu Reeves.jpeg',
    'filename': 'Keanu Reeves'
  },
  {
    'name': 'Kendall Jenner',
    'image': 'Kendall Jenner.jpeg',
    'filename': 'Kendall Jenner'
  },
  {
    'name': 'Kendrick Lamar',
    'image': 'Kendrick Lamar.jpeg',
    'filename': 'Kendrick Lamar'
  },
  {
    'name': 'Kevin Costner',
    'image': 'Kevin Costner.jpeg',
    'filename': 'Kevin Costner'
  },
  {
    'name': 'Kevin Durant',
    'image': 'Kevin Durant.jpeg',
    'filename': 'Kevin Durant'
  },
  {
    'name': 'Kevin Hart',
    'image': 'Kevin Hart.jpeg',
    'filename': 'Kevin Hart'
  },
  {
    'name': 'Khloe Kardashian',
    'image': 'Khloe Kardashian.jpeg',
    'filename': 'Khloe Kardashian'
  },
  {
    'name': 'Kid Cudi',
    'image': 'Kid Cudi.jpg',
    'filename': 'Kid Cudi'
  },
  {
    'name': 'Kim Kardashian',
    'image': 'Kim Kardashian.jpeg',
    'filename': 'Kim Kardashian'
  },
  {
    'name': 'Kimberly Loaiza',
    'image': 'Kimberly Loaiza.jpeg',
    'filename': 'Kimberly Loaiza'
  },
  {
    'name': 'Kirk Cousins',
    'image': 'Kirk Cousins.jpg',
    'filename': 'Kirk Cousins'
  },
  {
    'name': 'Kit Harington',
    'image': 'Kit Harington.jpeg',
    'filename': 'Kit Harington'
  },
  {
    'name': 'Kourtney Kardashian',
    'image': 'Kourtney Kardashian.jpg',
    'filename': 'Kourtney Kardashian'
  },
  {
    'name': 'Kristen Stewart',
    'image': 'Kristen Stewart.jpeg',
    'filename': 'Kristen Stewart'
  },
  {
    'name': 'Kylie Jenner',
    'image': 'Kylie Jenner.jpg',
    'filename': 'Kylie Jenner'
  },
  {
    'name': 'Lady Gaga',
    'image': 'Lady Gaga.jpeg',
    'filename': 'Lady Gaga'
  },
  {
    'name': 'Lana Del Rey',
    'image': 'Lana Del Rey.jpeg',
    'filename': 'Lana Del Rey'
  },
  {
    'name': 'Lara Stone',
    'image': 'Lara Stone.jpeg',
    'filename': 'Lara Stone'
  },
  {
    'name': 'Leonardo DiCaprio',
    'image': 'Leonardo DiCaprio.jpeg',
    'filename': 'Leonardo DiCaprio'
  },
  {
    'name': 'Letitia Wright',
    'image': 'Letitia Wright.jpg',
    'filename': 'Letitia Wright'
  },
  {
    'name': 'Lewis Hamilton',
    'image': 'Lewis Hamilton.jpeg',
    'filename': 'Lewis Hamilton'
  },
  {
    'name': 'Liam Hemsworth',
    'image': 'Liam Hemsworth.jpeg',
    'filename': 'Liam Hemsworth'
  },
  {
    'name': 'Lil Durk',
    'image': 'Lil Durk.jpeg',
    'filename': 'Lil Durk'
  },
  {
    'name': 'Lil Nas X',
    'image': 'Lil Nas X.jpeg',
    'filename': 'Lil Nas X'
  },
  {
    'name': 'Lil Peep',
    'image': 'Lil Peep.jpeg',
    'filename': 'Lil Peep'
  },
  {
    'name': 'Lil Tjay',
    'image': 'Lil Tjay.jpeg',
    'filename': 'Lil Tjay'
  },
  {
    'name': 'Lil Uzi Vert',
    'image': 'Lil Uzi Vert.jpeg',
    'filename': 'Lil Uzi Vert'
  },
  {
    'name': 'Lil Wayne',
    'image': 'Lil Wayne.jpg',
    'filename': 'Lil Wayne'
  },
  {
    'name': 'Lionel Messi',
    'image': 'Lionel Messi.jpeg',
    'filename': 'Lionel Messi'
  },
  {
    'name': 'Liu Wen',
    'image': 'Liu Wen.jpeg',
    'filename': 'Liu Wen'
  },
  {
    'name': 'Logan Lerman',
    'image': 'Logan Lerman.jpeg',
    'filename': 'Logan Lerman'
  },
  {
    'name': 'Louis Tomlinson',
    'image': 'Louis Tomlinson.jpeg',
    'filename': 'Louis Tomlinson'
  },
  {
    'name': 'Luisito Comunica',
    'image': 'Luisito Comunica.jpeg',
    'filename': 'Luisito Comunica'
  },
  {
    'name': 'Luke Combs',
    'image': 'Luke Combs.jpeg',
    'filename': 'Luke Combs'
  },
  {
    'name': 'Margot Robbie',
    'image': 'Margot Robbie.jpeg',
    'filename': 'Margot Robbie'
  },
  {
    'name': 'Marisa Tomei',
    'image': 'Marisa Tomei.jpeg',
    'filename': 'Marisa Tomei'
  },
  {
    'name': 'Mark Wahlberg',
    'image': 'Mark Wahlberg.jpeg',
    'filename': 'Mark Wahlberg'
  },
  {
    'name': 'Markiplier',
    'image': 'Markiplier.jpeg',
    'filename': 'Markiplier'
  },
  {
    'name': 'Matt Damon',
    'image': 'Matt Damon.jpeg',
    'filename': 'Matt Damon'
  },
  {
    'name': 'Matthew Gray Gubler',
    'image': 'Matthew Gray Gubler.jpeg',
    'filename': 'Matthew Gray Gubler'
  },
  {
    'name': 'Matthew McConaughey',
    'image': 'Matthew McConaughey.jpeg',
    'filename': 'Matthew McConaughey'
  },
  {
    'name': 'Meek Mill',
    'image': 'Meek Mill.jpeg',
    'filename': 'Meek Mill'
  },
  {
    'name': 'Megan Thee Stallion',
    'image': 'Megan Thee Stallion.jpeg',
    'filename': 'Megan Thee Stallion'
  },
  {
    'name': 'Mercedes Mason',
    'image': 'Mercedes Mason.jpeg',
    'filename': 'Mercedes Mason'
  },
  {
    'name': 'Michael Douglas',
    'image': 'Michael Douglas.jpeg',
    'filename': 'Michael Douglas'
  },
  {
    'name': 'Michael Phelps',
    'image': 'Michael Phelps.jpeg',
    'filename': 'Michael Phelps'
  },
  {
    'name': 'Miley Cyrus',
    'image': 'Miley Cyrus.jpeg',
    'filename': 'Miley Cyrus'
  },
  {
    'name': 'Miranda Kerr',
    'image': 'Miranda Kerr.jpeg',
    'filename': 'Miranda Kerr'
  },
  {
    'name': 'MrBeast',
    'image': 'MrBeast.jpeg',
    'filename': 'MrBeast'
  },
  {
    'name': 'Natalia Vodianova',
    'image': 'Natalia Vodianova.jpeg',
    'filename': 'Natalia Vodianova'
  },
  {
    'name': 'Natalie Portman',
    'image': 'Natalie Portman.jpg',
    'filename': 'Natalie Portman'
  },
  {
    'name': 'Neymar Jr',
    'image': 'Neymar Jr.jpeg',
    'filename': 'Neymar Jr'
  },
  {
    'name': 'Nicholas Hoult',
    'image': 'Nicholas Hoult.jpeg',
    'filename': 'Nicholas Hoult'
  },
  {
    'name': 'Nick Jonas',
    'image': 'Nick Jonas.jpeg',
    'filename': 'Nick Jonas'
  },
  {
    'name': 'Nicki Minaj',
    'image': 'Nicki Minaj.jpeg',
    'filename': 'Nicki Minaj'
  },
  {
    'name': 'Nina Dobrev',
    'image': 'Nina Dobrev.jpeg',
    'filename': 'Nina Dobrev'
  },
  {
    'name': 'Novak Djokovic',
    'image': 'Novak Djokovic.jpeg',
    'filename': 'Novak Djokovic'
  },
  {
    'name': 'Olivia Rodrigo',
    'image': 'Olivia Rodrigo.jpeg',
    'filename': 'Olivia Rodrigo'
  },
  {
    'name': 'Park Jimin',
    'image': 'Park Jimin.jpg',
    'filename': 'Park Jimin'
  },
  {
    'name': 'Paul Rudd',
    'image': 'Paul Rudd.jpeg',
    'filename': 'Paul Rudd'
  },
  {
    'name': 'PewDiePie',
    'image': 'PewDiePie.jpeg',
    'filename': 'PewDiePie'
  },
  {
    'name': 'Pink',
    'image': 'Pink.jpeg',
    'filename': 'Pink'
  },
  {
    'name': 'Pom Klementieff',
    'image': 'Pom Klementieff.jpeg',
    'filename': 'Pom Klementieff'
  },
  {
    'name': 'Post Malone',
    'image': 'Post Malone.jpeg',
    'filename': 'Post Malone'
  },
  {
    'name': 'Rafael Nadal',
    'image': 'Rafael Nadal.jpeg',
    'filename': 'Rafael Nadal'
  },
  {
    'name': 'Raviv Ullman',
    'image': 'Raviv Ullman.jpeg',
    'filename': 'Raviv Ullman'
  },
  {
    'name': 'Ray Fisher',
    'image': 'Ray Fisher.jpeg',
    'filename': 'Ray Fisher'
  },
  {
    'name': 'Reese Witherspoon',
    'image': 'Reese Witherspoon.jpeg',
    'filename': 'Reese Witherspoon'
  },
  {
    'name': 'Rege Jean Page',
    'image': 'Rege Jean Page.jpeg',
    'filename': 'Rege Jean Page'
  },
  {
    'name': 'RezendeEvil',
    'image': 'RezendeEvil.jpeg',
    'filename': 'RezendeEvil'
  },
  {
    'name': 'Ricky Whittle',
    'image': 'Ricky Whittle.jpeg',
    'filename': 'Ricky Whittle'
  },
  {
    'name': 'Rihanna',
    'image': 'Rihanna.jpg',
    'filename': 'Rihanna'
  },
  {
    'name': 'Robert Downey Jr',
    'image': 'Robert Downey Jr.jpeg',
    'filename': 'Robert Downey Jr'
  },
  {
    'name': 'Robert Pattinson',
    'image': 'Robert Pattinson.jpeg',
    'filename': 'Robert Pattinson'
  },
  {
    'name': 'Roger Federer',
    'image': 'Roger Federer.jpeg',
    'filename': 'Roger Federer'
  },
  {
    'name': 'Ryan Reynolds',
    'image': 'Ryan Reynolds.jpeg',
    'filename': 'Ryan Reynolds'
  },
  {
    'name': 'Sam Smith',
    'image': 'Sam Smith.jpeg',
    'filename': 'Sam Smith'
  },
  {
    'name': 'Sandra Bullock',
    'image': 'Sandra Bullock.jpeg',
    'filename': 'Sandra Bullock'
  },
  {
    'name': 'Scarlett Johansson',
    'image': 'Scarlett Johansson.jpeg',
    'filename': 'Scarlett Johansson'
  },
  {
    'name': 'Sebastian Stan',
    'image': 'Sebastian Stan.jpeg',
    'filename': 'Sebastian Stan'
  },
  {
    'name': 'Selena Gomez',
    'image': 'Selena Gomez.jpeg',
    'filename': 'Selena Gomez'
  },
  {
    'name': 'Seth Rogen',
    'image': 'Seth Rogen.jpeg',
    'filename': 'Seth Rogen'
  },
  {
    'name': 'Shakira',
    'image': 'Shakira.jpeg',
    'filename': 'Shakira'
  },
  {
    'name': 'Shaun White',
    'image': 'Shaun White.jpeg',
    'filename': 'Shaun White'
  },
  {
    'name': 'Shawn Mendes',
    'image': 'Shawn Mendes.jpeg',
    'filename': 'Shawn Mendes'
  },
  {
    'name': 'Sia',
    'image': 'Sia.jpeg',
    'filename': 'Sia'
  },
  {
    'name': 'Simon Dominic',
    'image': 'Simon Dominic.jpeg',
    'filename': 'Simon Dominic'
  },
  {
    'name': 'Sophia Lillis',
    'image': 'Sophia Lillis.jpeg',
    'filename': 'Sophia Lillis'
  },
  {
    'name': 'Stephen Curry',
    'image': 'Stephen Curry.jpeg',
    'filename': 'Stephen Curry'
  },
  {
    'name': 'Steve Smith',
    'image': 'Steve Smith.jpeg',
    'filename': 'Steve Smith'
  },
  {
    'name': 'Taron Egerton',
    'image': 'Taron Egerton.jpeg',
    'filename': 'Taron Egerton'
  },
  {
    'name': 'Taylor Lautner',
    'image': 'Taylor Lautner.jpeg',
    'filename': 'Taylor Lautner'
  },
  {
    'name': 'Taylor Momsen',
    'image': 'Taylor Momsen.jpeg',
    'filename': 'Taylor Momsen'
  },
  {
    'name': 'Taylor Swift',
    'image': 'Taylor Swift.jpeg',
    'filename': 'Taylor Swift'
  },
  {
    'name': 'The Weeknd',
    'image': 'The Weeknd.jpeg',
    'filename': 'The Weeknd'
  },
  {
    'name': 'Theo James',
    'image': 'Theo James.jpeg',
    'filename': 'Theo James'
  },
  {
    'name': 'Tiger Woods',
    'image': 'Tiger Woods.jpeg',
    'filename': 'Tiger Woods'
  },
  {
    'name': 'Tom Brady',
    'image': 'Tom Brady.jpeg',
    'filename': 'Tom Brady'
  },
  {
    'name': 'Tom Cruise',
    'image': 'Tom Cruise.jpeg',
    'filename': 'Tom Cruise'
  },
  {
    'name': 'Tom Felton',
    'image': 'Tom Felton.jpeg',
    'filename': 'Tom Felton'
  },
  {
    'name': 'Tom Hanks',
    'image': 'Tom Hanks.jpeg',
    'filename': 'Tom Hanks'
  },
  {
    'name': 'Tom Hardy',
    'image': 'Tom Hardy.jpeg',
    'filename': 'Tom Hardy'
  },
  {
    'name': 'Tom Hiddleston',
    'image': 'Tom Hiddleston.jpg',
    'filename': 'Tom Hiddleston'
  },
  {
    'name': 'Tom Holland',
    'image': 'Tom Holland.jpeg',
    'filename': 'Tom Holland'
  },
  {
    'name': 'Travis Scott',
    'image': 'Travis Scott.jpeg',
    'filename': 'Travis Scott'
  },
  {
    'name': 'Trisha',
    'image': 'Trisha.jpeg',
    'filename': 'Trisha'
  },
  {
    'name': 'Ty Simpkins',
    'image': 'Ty Simpkins.jpeg',
    'filename': 'Ty Simpkins'
  },
  {
    'name': 'Tyga',
    'image': 'Tyga.jpg',
    'filename': 'Tyga'
  },
  {
    'name': 'Usain Bolt',
    'image': 'Usain Bolt.jpeg',
    'filename': 'Usain Bolt'
  },
  {
    'name': 'Vegetta777',
    'image': 'Vegetta777.jpeg',
    'filename': 'Vegetta777'
  },
  {
    'name': 'Vin Diesel',
    'image': 'Vin Diesel.jpeg',
    'filename': 'Vin Diesel'
  },
  {
    'name': 'Wayne Rooney',
    'image': 'Wayne Rooney.jpeg',
    'filename': 'Wayne Rooney'
  },
  {
    'name': 'Will Poulter',
    'image': 'Will Poulter.jpeg',
    'filename': 'Will Poulter'
  },
  {
    'name': 'Will Smith',
    'image': 'Will Smith.jpeg',
    'filename': 'Will Smith'
  },
  {
    'name': 'Zac Efron',
    'image': 'Zac Efron.jpeg',
    'filename': 'Zac Efron'
  },
  {
    'name': 'Zachary Levi',
    'image': 'Zachary Levi.jpeg',
    'filename': 'Zachary Levi'
  },
  {
    'name': 'Zack Lugo',
    'image': 'Zack Lugo.jpeg',
    'filename': 'Zack Lugo'
  },
  {
    'name': 'Zayn Malik',
    'image': 'Zayn Malik.jpeg',
    'filename': 'Zayn Malik'
  },
  {
    'name': 'Zendaya',
    'image': 'Zendaya.jpeg',
    'filename': 'Zendaya'
  },
  {
    'name': 'Zoe Saldana',
    'image': 'Zoe Saldana.jpeg',
    'filename': 'Zoe Saldana'
  }
]
